import React, { useEffect, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Tab,
  Tabs,
  Autocomplete,
  TextField,
  DialogActions,
  Box,
  DialogContent,
} from "@mui/material";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import SchedulerDetailsTable from "./SchedulerView/SchedulerDetailsViewWithTable/SchedulerDetailsTable.tsx";
import Scheduler from "../../Scheduler";
import AddItemScheduler from "./AddItemScheduler.js";

function AddItemSchedulerDialog(props) {
  const [schedulerDatas, setSchedulerDatas] = useState([]);
  const [scheduleSelections, setScheduleSelections] = useState([]); // Stores selected schedules for each section
  const [sectionSchedulers, setSectionSchedulers] = useState({}); // Stores detailed schedulers for each section
  const [selectedTab, setSelectedTab] = useState(0); // Currently active section tab
  const [value, setValue] = useState("SaleHourSchedule"); // Active tab within a section (SaleHourSchedule or InventoryScheduler)
  const apiAddress = process.env.REACT_APP_SECRET;
  const [open, setOpen] = useState(false);
  
    props.prevScheduleSelecection(scheduleSelections);
  
    console.log(scheduleSelections)
  useEffect(() => {
    loadSchedules();
  }, []);

  // Load available schedules from API
  const loadSchedules = async () => {
    try {
      const response = await axios.get(`${apiAddress}/api/Schedule`);
      const temp = response.data.map((dt) => ({
        id: dt.scheduleId,
        title: dt.scheduleName,
      }));
      setSchedulerDatas(temp);
    } catch (error) {
      toast.error(error.response?.data || "Failed to load schedules", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  // Fetch schedule details for a specific section
  const fetchScheduleDetails = async (sectionId, selectedSchedules) => {
    try {
      const response = await axios.post(
        `${apiAddress}/api/Schedule/getschedulebyidlist`,
        selectedSchedules
      );
      setSectionSchedulers((prev) => ({
        ...prev,
        [sectionId]: response.data.schedulerDatas,
      }));
    } catch (error) {
      toast.error(error.response?.data || "Failed to fetch schedule details", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  const sethandleInventoryDetails = (data) => {
    props.handleInventorySave(data);
  };

  // const sethandleInventoryDetails = (data) => {
  //   // Combine all relevant data for each sectionId
  //   const formattedData = Object.keys(scheduleSelections).map((sectionId) => ({
  //     sectionId,
  //     scheduleDetails: scheduleSelections[sectionId], // Schedule info for the section
  //     additionalDetails: data, // Additional inventory data
  //   }));
  
  //   // Call the parent handler with the formatted data
  //   props.handleInventorySave(formattedData);
  // };
  
  

  // Handle tab change (switching sections)
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Handle internal tab change (SaleHourSchedule/InventoryScheduler)
  const handleInternalTabChange = (event, newValue) => {
    setValue(newValue);
  };

  // Handle schedule change for a section
  const handleScheduleChange = (sectionId, newValue) => {
    setScheduleSelections((prev) => ({
      ...prev,
      [sectionId]: newValue,
    }));

    if (newValue) {
      fetchScheduleDetails(sectionId, [newValue.id]);
    } else {
      setSectionSchedulers((prev) => ({
        ...prev,
        [sectionId]: [],
      }));
    }
  };

  const activeSectionId =
    props.selectedSectionDatas[selectedTab]?.id || "default";
    const activeSectionTitle =
    props.selectedSectionDatas[selectedTab]?.title || "Untitled Section";
  const activeSchedules = scheduleSelections[activeSectionId] || [];
  const activeDetailedSchedules = sectionSchedulers[activeSectionId] || [];

  console.log(activeSectionTitle)
  console.log(activeSectionId)
  console.log(activeDetailedSchedules )
  console.log(activeSchedules);

  return (
    <div>
      <Grid container sx={{ padding: "0.5rem", marginTop: "1rem" }}>
        <Grid item xs={12}>
          {/* Section Tabs */}
          <DialogActions sx={{ justifyContent: "flex-start" }}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              {props.selectedSectionDatas?.map((section) => (
                <Tab key={section.id} label={section.title} />
              ))}
            </Tabs>
          </DialogActions>

          {/* Internal Tabs for SaleHourSchedule and InventoryScheduler */}
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <Box sx={{ width: "100%", marginTop: "1rem" }}>
              <Tabs
                value={value}
                onChange={handleInternalTabChange}
                aria-label="wrapped label tabs example"
              >
                <Tab value="SaleHourSchedule" label="Sale Hour Schedule" />
                <Tab value="InventoryScheduler" label="Inventory Scheduler" />
              </Tabs>
            </Box>

            {/* Sale Hour Schedule Tab */}
            {value === "SaleHourSchedule" && (
              <>
                <Grid container>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Select Schedule
                    </Typography>
                  </Grid>
                  <Grid item xs={7} style={{ paddingTop: "1rem" }}>
                    {/* {JSON.stringify(scheduleSelections)} */}
                    <Autocomplete
                      id={`single-select-${activeSectionId}`}
                      options={schedulerDatas}
                      getOptionLabel={(option) => option.title}
                      value={scheduleSelections[activeSectionId]}
                      onChange={(event, newValue) =>
                        handleScheduleChange(activeSectionId, newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Schedule"
                          variant="outlined"
                        />
                      )}
                      sx={{ width: "100%", paddingY: ".5rem" }}
                    />
                  </Grid>
                </Grid>

                {activeDetailedSchedules.length > 0 && (
                  <SchedulerDetailsTable
                    addedtempSchedulers={activeDetailedSchedules}
                  />
                )}
              </>
            )}

            {/* Inventory Scheduler Tab */}
            {value === "InventoryScheduler" && (
              <>
                <Grid container>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Inventory Scheduler
                    </Typography>
                  </Grid>
                  <Grid item xs={10} style={{ paddingTop: "1rem" }}>
                    <Autocomplete
                      id={`inventory-single-select-${activeSectionId}`}
                      options={schedulerDatas}
                      getOptionLabel={(option) => option.title}
                      value={scheduleSelections[activeSectionId]}
                      onChange={(event, newValue) =>
                        handleScheduleChange(activeSectionId, newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Schedule"
                          variant="outlined"
                        />
                      )}
                      sx={{ width: "100%", paddingY: ".5rem" }}
                    />
                  </Grid>
                </Grid>
                <AddItemScheduler
                    sectionId={activeSectionId}
                    sectionTitle={activeSectionTitle} // Pass the section title 
                    addedSchedulers={activeDetailedSchedules} 
                    handleInventoryDetails={sethandleInventoryDetails}
                />

              </>
            )}
          </DialogContent>
        </Grid>
      </Grid>
    </div>
  );
}

export default AddItemSchedulerDialog;
